import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";
import ConferencesPage from "@/pages/ConferencesPage";
import ConferenceDetail from "@/pages/ConferenceDetail";
import SpeakersPage from "@/pages/SpeakersPage";
import SpeakerDetail from "@/pages/SpeakerDetail";
import PapersPage from "@/pages/PapersPage";
import PaperDetail from "@/pages/PaperDetail";
import MapPage from "@/pages/MapPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import BookmarksPage from "@/pages/BookmarksPage";
import AdminPage from "@/pages/AdminPage";
import AboutPage from "@/pages/AboutPage";
import LegalPage from "@/pages/LegalPage";
import SettingsPage from "@/pages/SettingsPage";
import DevelopersPage from "@/pages/DevelopersPage";
import SponsorPage from "@/pages/SponsorPage";
import SponsorSuccessPage from "@/pages/SponsorSuccessPage";
import CfpPage from "@/pages/CfpPage";
import ProfilePage from "@/pages/ProfilePage";
import OrganizerPage from "@/pages/OrganizerPage";
import AdminAnalyticsPage from "@/pages/AdminAnalyticsPage";
import SpeakerProfileEditorPage from "@/pages/SpeakerProfileEditorPage";
import SpeakerInboxPage from "@/pages/SpeakerInboxPage";
import SpeakerUpgradeSuccessPage from "@/pages/SpeakerUpgradeSuccessPage";
import AdminPaymentsPage from "@/pages/AdminPaymentsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import BrandPage from "@/pages/BrandPage";

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/conferences" element={<ConferencesPage />} />
              <Route path="/conferences/:id" element={<ConferenceDetail />} />
              <Route path="/speakers" element={<SpeakersPage />} />
              <Route path="/speakers/me" element={<SpeakerProfileEditorPage />} />
              <Route path="/speakers/me/inbox" element={<SpeakerInboxPage />} />
              <Route path="/speakers/upgrade/success" element={<SpeakerUpgradeSuccessPage />} />
              <Route path="/speakers/:id" element={<SpeakerDetail />} />
              <Route path="/papers" element={<PapersPage />} />
              <Route path="/papers/:id" element={<PaperDetail />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/bookmarks" element={<BookmarksPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
              <Route path="/admin/payments" element={<AdminPaymentsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/terms" element={<LegalPage kind="terms" />} />
              <Route path="/privacy" element={<LegalPage kind="privacy" />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/developers" element={<DevelopersPage />} />
              <Route path="/sponsor" element={<SponsorPage />} />
              <Route path="/sponsor/success" element={<SponsorSuccessPage />} />
              <Route path="/cfp" element={<CfpPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/organize" element={<OrganizerPage />} />
              <Route path="/brand" element={<BrandPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
